import React from 'react';
import { ReportingShellContainerBaseConfig } from '../../../base';
import {
    TemplateDetailContainerProps,
    TemplateDetailRouteProps,
} from './templateDetailProps';
import { Router } from '../../../../../../base';

export function createTemplateDetailRoute(
    config: ReportingShellContainerBaseConfig,
    Container: React.FC<TemplateDetailContainerProps>
): React.FC<TemplateDetailRouteProps> {
    const {
        router: {
            insert: { useParams },
        },
    } = config;

    return ({ overlay, ...routeProps }) => {
        const params = useParams(['templateId']);
        return <Container template={{ id: params.templateId }} overlay={overlay} />;
    };
}
